<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Demanda de biomasa</h1>
      <hr>
    </div>
    <div>

      <dai-tarjeta-contenedor-mapa  :permitir-colapso="true" :es-version-escritorio-en-pantalla-larga="false">
      
        <template v-slot:header>
            <h3>Demanda residencial de biomasa</h3>
            
            <p>Este mapa nos muestra el consumo de leña por municipio en México. Las tonalidades rojas indican los municipios con mayor consumo y las verdes las de menor consumo. Al dar clic sobre un munucipio se despliega la información del mismo.</p>
            <p>Datos en toneladas de materia seca por año (tMS/año)</p>

            <dai-leyenda-mapa v-width-control="'70%'"
            titulo="Demanda residencial de leña por municipio 2020 (tMS)"
            :para="['demanda_residencial']"
            :tamanosDeMapa="true"
            />
            
             <dai-interruptor-mapa v-width-control="'30%'"
            v-model="capa_prendida"
            :opciones="['Mapa','Satélite']"
            /> 

            

            
        </template>

        <dai-mapa
        :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
        >
            
        
        <dai-capa-xyz id="Mapa" :visible="capa_prendida==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

        <dai-capa-xyz id="Satélite" :visible="capa_prendida==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>


        <dai-capa-topojson  :opacidad="1"
            id="demanda_residencial" 
            url="../geodata/biomasa/demanda_residencial2020.json"
            titulo="Demanda residencial de leña por municipio"
            :zoom-al-dar-click="false"
            :contenidoPopup="(feat)=>`<b>Municipio:</b> ${feat.nom_mun}, ${feat.nom_ent}<br><b>Demanda:</b> ${feat.consumo_to.toFixed(2)} tDM`"
            :estilo-capa="{
            stroke:{
                color:'#333',                
                width:0.5
              }
            }"
            :reglas-estilo-capa="{
                clasificacion:'personalizada',
                columna : 'consumo_to',
                propiedadObjetivo: 'relleno',
                clases: 5,
                clasificacionPersonalizada: [[0,1000],[1000,5000],[5000,10000],[10000,20000],[20000,250000]],
                colores: ['#37a800', '#8dcf00','#ffff01','#f78106','#fe0000'],
            }"
          />

        </dai-mapa>
          
      </dai-tarjeta-contenedor-mapa>

      <br>

      <dai-tarjeta-contenedor-mapa  :permitir-colapso="true" :es-version-escritorio-en-pantalla-larga="false">
      
        <template v-slot:header>
            <h3>Demanda industrial de biomasa</h3>
            
            <p>Se visualiza la distribución de las plantas de producción de calor y/o electricidad utilizando como combustible biogás o bagazo de caña de azúcar. La capacidad instalada de las centrales varía de 70 kW (motogenerador de biogás) hasta los 50 MW (turbina de vapor con caldera de bagazo). Al dar clic sobre un punto se despliega la información de la planta.</p>

            <dai-leyenda-mapa v-width-control="'70%'"
            titulo=""
            :para="['bioenergia']"
            />

            <dai-interruptor-mapa v-width-control="'30%'"
            v-model="capa_prendida2"
            :opciones="['Mapa','Satélite']"
            /> 

        </template>

        <dai-mapa
        :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
        >
            
        <dai-capa-xyz id="Mapa" :visible="capa_prendida2==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>

        <dai-capa-xyz id="Satélite" :visible="capa_prendida2==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>


        <dai-capa-geojson 
        id="bioenergia"
        titulo="Plantas generadoras de bioenergía"
        :zoom-al-dar-click="false"
        :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.central}<br><b>Capacidad:</b> ${feat.capacid_mw}MW<br><b>Combustible:</b> ${feat.energet_pr}`"
        url="../geodata/biomasa/bioenergia.geojson"
        :estilo-capa="{
            circle:{
                fill:{color:'#089529'},
                stroke:{color:'#232323',width:1},
                radius:4}
            }"
        />

        </dai-mapa>
          
      </dai-tarjeta-contenedor-mapa>
      

    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
        <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
        <ul class="lista-referencias">
          <li><em><strong>Geocomunes (2020).&nbsp;</strong></em>Alumbrar las contradicciones del Sistema El&eacute;ctrico Mexicano y de la transici&oacute;n energ&eacute;tica. Preguntas clave para entenderlos y construir otros modelos energ&eacute;ticos. Ciudad de M&eacute;xico. Fundaci&oacute;n Rosa Luxemburgo. <a href="http://geocomunes.org/Visualizadores/SistemaElectricoMexico/">http://geocomunes.org/Visualizadores/SistemaElectricoMexico/</a></li>
          <li><em><strong>Modificado de; Serrano-Medrano, M., T. Arias-Chalico, A. Ghilardi, and O. Masera. 2014.</strong></em> Spatial and temporal projection of fuelwood and Charcoal consumption in Mexico. Energy for Sustainable Development (19) 2014 39-46. https://doi.org/10.1016/j.esd.2013.11.007</li>
          <li><em><strong>Comisión Reguladora de Energía (CRE). Registro público del órgano de gobierno (2022).</strong></em>  Recuperado en diciembre de 2022. <a href="https://www.cenace.gob.mx/" target="_blank">https://www.cenace.gob.mx/</a></li>
        </ul>            
    </div>

  </div>
</template>
<script>
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  

  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
      
    },
    data: function () {
      return {
        opacidad_capa:1,
        capa_prendida: 'Mapa',
        capa_prendida2: 'Mapa'
      }   
    },
    mounted() {



    },
    beforeDestroy() {
     
    },
  }

</script>
<style scoped lang="scss">


</style>
